import type React from 'react'

import css from './styles.module.css'

export const Divider: React.FC = () => <div className={css.divider} />
